module.exports = ".goback {\n  margin: 24px 0 0 !important; }\n\n.login-wrapper {\n  margin: -24px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main